import type { IconData } from '@stacksjs/iconify-core'

export const basicUiQuestion2: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m3.125-9.875c0 1.726-1.4 3.125-3.125 3.125h-.5V6.5H4.875v-.375a3.125 3.125 0 1 1 6.25 0M9.5 11.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiQuestion2
